import {useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import {settingsRedux} from './redux';
import {Settings} from './types';

export const useSettingsActions = () => {
  const dispatch = useDispatch();

  const add = useCallback(
    (data: Settings) => {
      dispatch(settingsRedux.actions.add([data]));
    },
    [dispatch],
  );

  const update = useCallback(
    (userId: number, data: any) => {
      dispatch(settingsRedux.actions.update(userId, data));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      add,
      update,
    }),
    [update, add],
  );
};
